import {
  CHECK_FETCH_REQUEST,
  CHECK_FETCH_SUCCESS,
  CHECK_FETCH_FAILURE,
  CHECK_CLEAR
} from './checkActions'

const INITIAL_STATE = {
  itens: [],
  total: 0,
  filtros: {
    dataInicial: '',
    dataFinal: ''
  },
  loading: false,
  loaded: false,
  error: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CHECK_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      }

    case CHECK_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        itens: action.payload.itens,
        total: action.payload.total,
        filtros: action.payload.filtros
      }

    case CHECK_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      }

    case CHECK_CLEAR:
      return {
        ...INITIAL_STATE
      }

    default:
      return state
  }
}